import { render, staticRenderFns } from "./ChecklistProtocolPerson.vue?vue&type=template&id=441fc1eb&scoped=true&"
import script from "./ChecklistProtocolPerson.vue?vue&type=script&lang=js&"
export * from "./ChecklistProtocolPerson.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistProtocolPerson.vue?vue&type=style&index=0&id=441fc1eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441fc1eb",
  null
  
)

export default component.exports